import React from "react";
import WelcomeSection from "../common/WelcomeSection";
import ImageTextRow from "../common/ImageTextRow";
import { MISSION_VISION_ROWS } from "../../constants/contentSections";

function SectionTwoHomePage() {
  return (
    <WelcomeSection>
      {MISSION_VISION_ROWS.map((row) => (
        <ImageTextRow key={row.id} {...row} />
      ))}
      <div className="h-24" />
    </WelcomeSection>
  );
}

SectionTwoHomePage.revealManaged = true;

export default SectionTwoHomePage;
